import { Component, OnInit, SecurityContext } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDetailsContext } from '../germplasm-details.context';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParamContext } from '../../shared/service/param.context';
import { INVENTORY_DETAILS_URL } from '../../app.constants';
import { LoginService } from '../../shared/login/login.service';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-inventory-pane',
    templateUrl: './inventory-pane.component.html'
})
export class InventoryPaneComponent implements OnInit {

    safeUrl: SafeResourceUrl;

    constructor(public languageservice: JhiLanguageService,
                public translateService: TranslateService,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private paramContext: ParamContext,
                private sanitizer: DomSanitizer,
                private loginService: LoginService,
                private urlService: UrlService
    ) {
        const queryParams = `?cropName=${paramContext.cropName}&programUUID=${paramContext.programUUID}&gid=${germplasmDetailsContext.gid}`;
        const urlStr = this.urlService.buildSafeUrl(INVENTORY_DETAILS_URL + queryParams);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.safeUrl = urlStr !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    ngOnInit(): void {
        // Explicitly validate token when this page is loaded. If token is invalid, browser will redirect to login page.
        this.loginService.validateToken().toPromise().then(() => {
        });
    }

}
